import S_base from '@/services/wasaapi/__base';

export default {
  async createUnReleased(actId, data) {
    const res = await S_base.create({
      parentName: 'act',
      parentId: actId,
      modelName: 'act_version/unrelease',
      data,
    });
    return res;
  },
};